module.exports = __webpack_public_path__ + "static/media/icon3.d6a53daa.svg";